export function getMountedSlides(
  slidesInView: Set<number>,
  neighbors: number,
  totalSlides: number,
  loop: boolean,
): Set<number> {
  const mounted = new Set<number>();

  if (totalSlides <= 0) {
    return mounted;
  }

  for (const i of slidesInView) {
    const start = i - neighbors;
    const end = i + neighbors;

    for (let j = start; j <= end; j++) {
      let idx = j;

      if (loop) {
        // modulo wrap for negatives too
        idx = ((j % totalSlides) + totalSlides) % totalSlides;
      }

      if (!loop) {
        if (idx < 0 || idx >= totalSlides) {
          continue;
        }
      }

      mounted.add(idx);
    }
  }

  return mounted;
}
